import React, { PureComponent } from "react";

import axios from "axios";
import debounce from "lodash/debounce";

import Select from "react-select";
import AsyncSelect from "react-select/async";

import { FILTER_PROPERTIES, TTP_API_URL } from "Config";
import styles from "./Condition.local.scss";
import classnames from "classnames";
import _ from "i18n";

import { selectStyle } from "./SelectStyle";

export default class ConditionComponent extends PureComponent {
  state = {
    selectedValue: this.props.condition
      ? {
          value: this.props.condition.value
        }
      : null,
    selectedProperty: this.props.condition
      ? this.props.condition.property
      : FILTER_PROPERTIES[this.props.type].filter(prop => prop.isDefault)[0]
          .property,
    selectedOperator: this.props.condition
      ? this.props.condition.operator
      : "eq"
  };

  handleChange = selectedValue => {
    const { order, addCondition } = this.props;
    const { selectedProperty, selectedOperator } = this.state;

    addCondition(order, {
      property: selectedProperty,
      value: selectedValue.value || selectedValue.id,
      operator: selectedOperator
    });
    this.setState({ selectedValue });
  };

  changeProperty = e => {
    this.setState({ selectedProperty: e.currentTarget.value });
  };

  changeOperator = e => {
    this.setState({ selectedOperator: e.currentTarget.value });
  };

  getOptions() {
    const { categories, types, themes, lng, type } = this.props;

    const nameAttr = `name${lng.charAt(0).toUpperCase() + lng.slice(1)}`;

    let options = [];
    const { label } = FILTER_PROPERTIES[type].filter(
      prop => prop.property === this.state.selectedProperty
    )[0];
    switch (label) {
      case "category":
        options = categories.items.map(category => ({
          label: category[nameAttr],
          value: category.id
        }));
        break;
      case "type":
        options = types.items.map(type => ({
          label: type.name,
          value: type.id
        }));
        break;
      case "theme":
        if (themes && themes.items) {
          options = themes.items.map(theme => ({
            label: theme.title,
            value: theme.id
          }));
        }
        break;
    }
    return options;
  }

  fetchTags = debounce((inputValue, callback) => {
    const { lng, auth, condition } = this.props;
    if (!auth || !auth.navCommunity) {
      return callback([]);
    }

    const { token, navCommunity } = auth;

    const requestUrl = `${TTP_API_URL}/blog/tag`;
    const filters = [];
    const fields = [];

    if (inputValue && inputValue.length > 0) {
      filters.push({
        property: `name${lng.charAt(0).toUpperCase() + lng.slice(1)}`,
        value: inputValue,
        operator: "like"
      });
    } else if (condition && condition.value) {
      filters.push({
        property: "id",
        value: condition.value,
        operator: "eq"
      });
    }

    if (this.lastTagRequestSource) {
      this.lastTagRequestSource.cancel();
    }

    const CancelToken = axios.CancelToken;
    const source = CancelToken.source();

    this.lastTagRequestSource = source;

    axios
      .get(requestUrl, {
        cancelToken: source.token,
        params: {
          access_token: token,
          organization_id: navCommunity ? navCommunity.id : null,
          fields: fields.join(","),
          filter: JSON.stringify(filters)
        }
      })
      .then(resp => {
        const { data } = resp.data;
        if (condition && condition.value) {
          this.setState({ selectedValue: { ...data[0] } });
        }
        /*this.setState(({ conditions }) => ({
          conditions: conditions.map(c => {
            if (
              c.property &&
              c.property.value === "tag" &&
              c.operator &&
              c.operator.value &&
              c.value &&
              Object.keys(c.value).length === 1 &&
              Object.keys(c.value)[0] === "id"
            ) {
              let value = c.value;
              if (c.operator.value === "in") {
                value = c.value.map(v => {
                  const tag = this.tags.find(cat => cat.id === v.id);
                  return tag || v;
                });
              } else if (c.operator.value === "eq") {
                const tag = this.tags.find(cat => cat.id === c.value.id);
                value = tag;
              }

              return { ...c, value };
            }

            return c;
          })
        }));*/

        callback(data);
      })
      .catch(() => callback([]));
  }, 200);

  render() {
    const { type, minusRow, addRow, nbRows, cpt, condition, lng } = this.props;
    const { selectedValue, selectedOperator, selectedProperty } = this.state;

    const options = this.getOptions();
    let helpValue = selectedValue ? { ...selectedValue } : null;

    if (
      selectedValue &&
      !selectedValue.label &&
      options &&
      options.length > 0
    ) {
      const help = Array.isArray(selectedValue.value)
        ? "DOCUMENT"
        : selectedValue.value;
      helpValue.label = options.filter(option => option.value == help)[0].label;
    }

    const { label } = FILTER_PROPERTIES[type].filter(
      prop => prop.property === this.state.selectedProperty
    )[0];

    const nameAttr = `name${lng.charAt(0).toUpperCase() + lng.slice(1)}`;

    return (
      <div className={styles.condition}>
        <div className={styles.condInputs}>
          <select
            className={classnames(styles.filled, styles.property)}
            onChange={this.changeProperty.bind(this)}
            value={selectedProperty}
          >
            {FILTER_PROPERTIES[type].map(prop => (
              <option key={prop.property} value={prop.property}>
                {_(prop.label)}
              </option>
            ))}
          </select>
          <select
            className={classnames(styles.filled, styles.operator)}
            onChange={this.changeOperator.bind(this)}
            value={selectedOperator}
          >
            <option value="eq">{_("equal")}</option>
            <option value="neq">{_("different")}</option>
            <option value="in">{_("contains")}</option>
          </select>
          {label !== "tag" ? (
            <Select
              styles={selectStyle()}
              value={helpValue}
              onChange={this.handleChange}
              options={options}
            />
          ) : (
            <AsyncSelect
              styles={selectStyle()}
              isMulti={selectedOperator === "in" ? true : false}
              loadOptions={this.fetchTags}
              defaultOptions
              getOptionLabel={option => option[nameAttr]}
              getOptionValue={option => option.id}
              value={helpValue}
              onChange={this.handleChange}
              placeholder={""}
              loadingMessage={() => _("Loading...")}
              noOptionsMessage={() => null}
              openMenuOnClick={true}
            />
          )}
        </div>
        <div className={styles.plusMinus}>
          {nbRows === 1 ? null : (
            <span className={styles.minus} onClick={minusRow.bind(this)} />
          )}
          {cpt === nbRows - 1 && nbRows < FILTER_PROPERTIES[type].length ? (
            <span className={styles.plus} onClick={addRow.bind(this)} />
          ) : null}
        </div>
      </div>
    );
  }
}



// WEBPACK FOOTER //
// ./src/components/Settings/ManageLayout/Bloc/Filter/Condition/ConditionComponent.js